import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, forwardRef } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { 
    IonGrid, IonRow, IonCol, ToastController
} from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { 
    MarvButtonComponent, MarvInputDateComponent
} from '@marv/components';
import { MarvDateService } from '@marv/services';
import { StoreCheckService } from '@app/services';
import { StoreCheck } from '@app/models';

@Component({
    selector: 'app-permanent-planning-storecheck-duplicate',
    templateUrl: './duplicate.component.html',
    styleUrls: ['./duplicate.component.scss'],
    imports: [
        IonGrid, IonRow, IonCol, TranslatePipe, ReactiveFormsModule, 
        forwardRef(() => MarvButtonComponent), forwardRef(() => MarvInputDateComponent)
    ]
})
export class PermanentPlanningStorecheckDuplicateComponent  implements OnInit {

    @Input({alias : 'operationId', required : true}) operationId: number;
    @Input({alias : 'storeCheckId', required : true}) storeCheckId: number;
    @Output() onDuplicateStoreCheck = new EventEmitter<number|null>();
    
    isFetchingDuplicate: boolean = false;
    storeCheck : StoreCheck|null = null;
    permanentPlanningStoreCheckDuplicateForm: FormGroup = new FormGroup({
        day: new FormControl(null, [Validators.required]),
    });
    
    constructor(
        public translateService: TranslateService,
        private toastController: ToastController,
        private storeCheckService: StoreCheckService
    ) { }

    ngOnInit() {}

    async ngOnChanges(changes: SimpleChanges) {
        if(changes['storeCheckId']){
            await this.loadStoreCheck();
        }
    }
    
    async loadStoreCheck(){
        let storeCheck : StoreCheck|null = null;
        let values: any = {
            day: null
        };
        if(this.storeCheckId && this.operationId){
            storeCheck = await this.storeCheckService.loadStoreCheck(this.operationId, this.storeCheckId);
            if(storeCheck?.firstProgrammableDate){
                values.day = new Date(storeCheck.firstProgrammableDate);
            }
        }
        this.storeCheck = storeCheck;    
        this.permanentPlanningStoreCheckDuplicateForm.setValue(values);
    }
    
    async duplicate() {
        if(this.storeCheck){
            if(this.permanentPlanningStoreCheckDuplicateForm.valid){  
                this.isFetchingDuplicate = true;
                
                let newStoreCheckId = await this.storeCheckService.duplicateStoreCheck(this.storeCheck.contextId, this.storeCheck.id, this.permanentPlanningStoreCheckDuplicateForm.controls['day'].value);

                if(newStoreCheckId){                
                    this.onDuplicateStoreCheck.emit(newStoreCheckId);
                    this.resetForm();
                    const toast = await this.toastController.create({
                        message: this.translateService.instant('MSG_SUCCESS_DUPLICATE_STORECHECK'),
                        duration: 6000,
                        position: 'top',
                        color: 'success'
                    });
                    await toast.present();
                }
                else{
                    const toast = await this.toastController.create({
                        message: this.translateService.instant('MSG_ERROR_DUPLICATE_STORECHECK'),
                        duration: 6000,
                        position: 'top',
                        color: 'danger'
                    });
                    await toast.present();
                }
                
                this.isFetchingDuplicate = false;
            }
            else{
                for (var controlName in this.permanentPlanningStoreCheckDuplicateForm.controls) {
                    if(!this.permanentPlanningStoreCheckDuplicateForm.controls[controlName].valid) {
                        this.permanentPlanningStoreCheckDuplicateForm.controls[controlName].markAsTouched();
                    }
                }
           }
        }
    }

    cancel(){
        this.resetForm();
        this.onDuplicateStoreCheck.emit(null);
    }
    
    resetForm() {
        this.permanentPlanningStoreCheckDuplicateForm.reset();
    }
}
